<template>
  <el-table
    :data="consignment.items"
    style="width: 100%"
    size="small"
    striped
    border
    :summary-method="getSummaries"
    :show-summary="true"
  >
    <el-table-column type="expand">
      <template slot-scope="props">
        <ItemPeek :item="props.row" />
      </template>
    </el-table-column>
    <el-table-column
      prop="item_full"
      label="Item Number"
      width="180"
    />
    <el-table-column
      prop="item_ref"
      label="Reference"
      width="180"
    />
    <el-table-column
      prop="item_qty"
      label="Quantity"
    />
    <el-table-column
      prop="item_weight"
      label="Weight"
      :formatter="(row, col, cellValue) => cellValue + 'kg'"
    />
    <el-table-column
      prop="item_cube"
      label="Cube"
      :formatter="(row, col, cellValue) => cellValue + 'm3'"
    />
    <el-table-column
      prop="item_length"
      label="Length"
      :formatter="(row, col, cellValue) => cellValue + 'cm'"
    />
    <el-table-column
      prop="item_width"
      label="Width"
      :formatter="(row, col, cellValue) => cellValue + 'cm'"
    />
    <el-table-column
      prop="item_height"
      label="Height"
      :formatter="(row, col, cellValue) => cellValue + 'cm'"
    />
    <el-table-column
      prop="type.desc"
      label="Type"
    />
    <el-table-column
      prop="item_desc"
      label="Desc"
    />
    <el-table-column
      prop="itemdg_id"
      label="DG"
      :formatter="(row, col, cellValue) => cellValue > 0 ? 'Yes' : '-'"
    />
  </el-table>
</template>
<script>
import ItemPeek from './Peek'

export default {
  components: {
    ItemPeek
  },
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = 'Totals'
          return
        }
        if ([0, 2, 6, 7, 8, 9, 10, 11].includes(index)) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          let val = ''
          if (index === 4) {
            val = 'kg'
          } else if (index === 5) {
            val = 'm3'
          }
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0) + val
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    }
  }
}
</script>
